import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ReactComponent as InfoIcon } from 'shared/assets/icons/warning.svg';

import styles from './WarningPopoverContent.module.scss';

const WarningPopoverContent = ({ handleOk, title }: { handleOk: () => void; title: string }): React.ReactElement => {
  const { t } = useTranslation('Timesheet');

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <div>
          <InfoIcon width={14} height={14} />
        </div>
        <Typography.Text>{t(title)}</Typography.Text>
      </div>
      <div className={styles.buttonWrapper}>
        <Button type="primary" size="small" onClick={handleOk}>
          {t('statusWarningPopover.okBtn.text')}
        </Button>
      </div>
    </div>
  );
};

export { WarningPopoverContent };
